import { render } from "./CurrencySelect.vue?vue&type=template&id=f8883a52&scoped=true"
import script from "./CurrencySelect.vue?vue&type=script&lang=js"
export * from "./CurrencySelect.vue?vue&type=script&lang=js"

import "./CurrencySelect.vue?vue&type=style&index=0&id=f8883a52&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8883a52"]])

export default __exports__